import React from 'react';
import { AsButton } from '@adserve/adserve-react-components';
import {
    saveContainerStyle,
    saveButtonStyle,
    stickySaveContainerStyle,
    stickySaveButtonStyle
} from './SaveBarStyles';

const SaveBar = ({
    display = true,
    campaign,
    handleCreate,
    handleUpdate,
    campaignSaving,
    isSticky = false,
    readOnly = false
}) => {
    return (
        display && (
            <div
                style={isSticky ? stickySaveContainerStyle : saveContainerStyle}
            >
                <AsButton
                    id={'save-button'}
                    style={
                        isSticky ? stickySaveButtonStyle : saveButtonStyle
                    }
                    disabled={!campaign.modified || campaignSaving || readOnly}
                    handleClick={
                        campaign.id === window.emptyGuid
                            ? handleCreate
                            : handleUpdate
                    }
                >
                    {window.translate(campaignSaving ? 'Saving' : 'Save')}
                </AsButton>
            </div>
        )
    );
};

export default SaveBar;
